export type WeekPattern = "EVERY" | "ODD" | "EVEN";
export type WeekParity = "ODD" | "EVEN";

export const weekPatternOptions: ReadonlyArray<{
  value: WeekPattern;
  label: string;
}> = [
  { value: "EVERY", label: "每周" },
  { value: "ODD", label: "仅单周" },
  { value: "EVEN", label: "仅双周" }
];

export function weekPatternLabel(value: WeekPattern): string {
  return weekPatternOptions.find((item) => item.value === value)?.label ?? "每周";
}

export function weekParityLabel(value: WeekParity): string {
  return value === "ODD" ? "单周" : "双周";
}

export function activeWeekParities(value: WeekPattern): WeekParity[] {
  return value === "EVERY" ? ["ODD", "EVEN"] : [value];
}
